import React, { Component } from 'react';
import './ProgressBarList.css';
import ProgressBarItem from "./ProgressBarItem";
import staticElementObject from "../../staticElementObject";

class ProgressBarList extends Component {
    render() {

        var currentStep = this.props.currentStep;

        return (
            <div className="progressBarList col-xs-12">
                <ul>
                    {
                        staticElementObject.map(function(el) {
                            if(el.id < currentStep) {
                                var buttonStatusValue = 'progressItemDone'
                            }
                            if(el.id === currentStep) {
                                buttonStatusValue = 'progressItemCurrent'
                            }
                            return <ProgressBarItem
                                key={el.id}
                                stepName={el.stepName}
                                buttonStatus={buttonStatusValue}
                        />;
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default ProgressBarList;



// WEBPACK FOOTER //
// ./src/components/header/ProgressBarList.jsx